var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.056a3.57 3.57 0 00-1.393-2.874 3.22 3.22 0 01-1.719 1.464 3.128 3.128 0 001.75-2.789 3.177 3.177 0 00-3.224-3.136 2.13 2.13 0 00-.326.016c.377.836.585 1.739.61 2.656h-.048a7.735 7.735 0 00-15.3 0H4.3c.006-.904.198-1.798.563-2.625A5.475 5.475 0 000 10.252a5.632 5.632 0 005.708 5.554h14.517V15.8A3.799 3.799 0 0024 12.056z",
    fill: "#746DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.306A6 6 0 019.666 2.778a6.002 6.002 0 112.336 11.528zm0-11.272a5.272 5.272 0 100 10.545 5.272 5.272 0 000-10.545z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.373 10.728v-4.71a.938.938 0 01.938-.937h2.68a2.41 2.41 0 012.382 2.378 2.408 2.408 0 01-2.382 2.377h-1.743v.892a.937.937 0 11-1.875 0zm3.58-2.538a.732.732 0 100-1.463h-1.705V8.19h1.706z",
    fill: "#fff"
  })));
}
export default SvgPassLogo;